export default __webpack_public_path__ + "static/media/product-detail.30045f88.png";